
<!-- 
<div class="liveContainer">
  <div class="container-fluid" style="background: #0D0D0D;"> -->
    <!-- <div  class="cursor-pointer " style="z-index: 999;position: absolute;">
      <div class="back">
        <i class="fas fa-arrow-alt-left" (click)="backToInfo()"><span class="fs-16 fw-500"> {{'COMMON.BACK' |translate}} </span> </i>
      </div>
    </div> -->
    <!-- <div class="mx-auto player-contain series-contain" *ngIf="stream_Url" >
      <video id="example-videoplay" class="video-js player-video " controls autoplay  preload="none" 
        data-setup="{}"  controlslist="nodownload noplaybackrate">
        <source [src]="stream_Url" type="video/mp4" />
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
        </p>
      </video>
    </div> -->
  <!-- </div>
</div> -->


<!-- <div class="custom-modal" *ngIf="showModal">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
    </div>
    <div class="modal-body">
      <p class="text-dark">An error occurred during playing video.</p>
    </div>
    <div class="close">
      <button class="btn btn-primary" (click)="closePlayNext()">Close & Play Next</button>
    </div>
  </div>
</div> -->


<div class="video-container responsive-player" >
  <video class="video-container__video player" id="series-player" style="width: 100%;height: 100%;">
    <source [src]="stream_Url" type="video/mp4"/>
  </video>
  <div class="video-container__controls"> 
    <div class="control epg-image" (click)="backToInfo()">
      <div class="border-back" style="display: flex;justify-content: center;align-items: center; height: 2rem;width: 3rem;">
        <i class="fa fa-arrow-left fs-20"></i>
      </div>
    </div>
    <div class="control video-info">
    <div class="video-title fs-22 pl-4 pr-3 ">{{ videoTitle }}</div>
    </div>
    <button class="control control--backward">
      <i class="fas fa-backward"></i>
    </button>
    <button class="control control--play paused">
       <img class="fas fa-play" src="./assets/images/nio-icons/play_btn.svg" alt="">
      <i class="fas fa-pause"></i>
    </button>
    
    <button class="control control--forward">
      <i class="fas fa-forward"></i>
    </button>
    <button class="control control--replay pr-2">
      <i class="fas fa-sync fs-24"></i>
    </button>
    <!-- <button class="control control--favorite pr-2" (click)="toggleEPG()">
      <img src="./assets/images/nio-icons/series_episodes.svg" class="" alt="">
    </button>
    <button class="control  pr-2" *ngIf="isFavourit" (click)="deleteFavourites()">
      <img src="./assets/images/nio-icons/favourites_like_heart.svg" class="fas fa-heart" alt="">
    </button>
    <button class="control  pr-2" *ngIf="!isFavourit" (click)="onSaves()">
      <img src="./assets/images/nio-icons/favourites_heart.svg" class="fas fa-heart" alt="">
    </button> -->
    <button class="control control--fullscreen pr-2">
      <img class="fas fa-expand" src="./assets/images/nio-icons/fullscreen_player_icon.svg" alt="">
      <i class="fas fa-compress fs-28" (click)="closeFullscreen()"></i>
    </button>
      <!-- <button class="control control--caption pr-3">
        <img class="fas fa-closed-captioning" src="./assets/images/nio-icons/caption.svg" alt="">
      </button> -->
      <button class="control control--next" (click)="onClickplayNextEpisode()">
        <img src="./assets/images/nio-icons/next_play.svg" alt="">
      </button>
      <button class="control control--volume">
        <div class="control--volume__button">
          <img src="./assets/images/nio-icons/mute_volume.svg" class="fas fa-volume-off" alt="">
          <i class="fas fa-volume-up fs-24"></i>
        </div>
        <input class="control--volume__slider" value="0" type="range" min="0" max="1" step="0.01">
      </button>
      <div class="progress">
        <div class="progress__current"></div>
      </div>
      <div class="start-end-time">
       <div class="flex-time">
         <div class="start-time">
           <div class="video-duration  fs-20">{{ videoDuration }}</div>
          </div>
          <div class="end-time">
            <div class="video-duration  fs-20">{{ totalVideoDuration }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="season-upbar" [ngClass]="{'show': showSeasonBar}">
      <div class="close-season" (click)="closeSeason()">
        <button class="btn close-fa"><i class="fas fa-times"></i></button>
      </div>
      <div class="col-12 text-center cursor-pointer season-scroll-btn d-flex pt-4">
        <div class="season-name"  *ngFor="let item of seriesinfo?.seasons;let i=index;" class="d-flex" >
          <h4 class="episode-title d-flex  mr-5" (click)="onSelectSeason(item.season_number)" [ngClass]="{'border-all':item.season_number==seasonId}">{{item.name}}</h4>
        </div>
       </div>
      <div class="col-12 text-left pt-1 pb-4" *ngIf="seriesinfo?.episodes && !isLoading">
        <p *ngIf="!seriesinfo?.selectedEpisodes || (seriesinfo?.selectedEpisodes && seriesinfo.selectedEpisodes?.length == 0) || seriesinfo?.episodes.length > 0">{{'COMMON.DATA_NOT_FOUND' | translate}}</p>
        <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfigs">
          <div ngxSlickItem *ngFor="let item of seriesinfo.selectedEpisodes;let i=index;"
            class="slide cursor-pointer" style="position: relative;" (click)="playSerie(item.id,item.container_extension,item.title)" [routerLink]="['/series/watch/'+item.id+'/'+item.container_extension]">
            <div class="pr-3 pt-4" >
                <img class="search-imgseries" [src]="item.info.movie_image" defaultImage="./assets/images/series_lands_placeholder.svg" alt="First slide" loading=lazy>
            </div>
            <div class="row episode-shadow" style="margin-top: -2rem;">
              <div class="col-md-3" >
                <div class="season-number">
                  <p *ngIf="item.episode_num < 10">0{{item.episode_num}}</p>
                  <p *ngIf="item.episode_num >= 10">{{item.episode_num}}</p>
                </div>
              </div>
              <div class="col-md-9">
                <div class="episode-name-desc">
                  <p class="fs-14 search-title " title="{{ item.title }}">{{item.title }}</p>
                  <div class="season-desc">
                    <p>{{item?.info?.plot}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      
      </div>
    </div>

    <div class="show-next-coming-season" [ngClass]="{'show':showNextSeason}">
      <div class="next-play-title">
        <p>Next Episode Play in <span class="time-out-count">{{seriesTimeEnds}}</span></p>
      </div>
      <div class="pt-1 " >
        <img class="search-imgseriess" [src]="nextPlayImg" defaultImage="./assets/images/series_lands_placeholder.svg" alt="First slide" loading=lazy>
      </div>
    <div class="row episode-shadow" style="margin-top: -2rem;">
      <div class="col-md-3 mr-1" >
        <div class="season-numbers">
          <p>{{epNumber}}</p>
         
        </div>
      </div>
      <div class="col-md-8">
        <div class="episode-name-desc">
          <p class="fs-14 search-title " title="{{ nexttitles }}">{{titles}}</p>
          <div class="season-desc">
            <p>{{epDescription}}</p>
          </div>
        </div>
      </div>
      <div class="col-md action-btn">
        <div class="close-next">
          <button class="btn" (click)="cancelNext()">Cancel</button>
        </div>
        <div class="play-next">
          <button class="btn" (click)="onClickplayNextEpisode()">Watch Now</button>
        </div>
      </div>
    </div>
   </div> -->